export const normalizeUrlPath = (urlPath: string | null | undefined) => {
  if (!urlPath) {
    return null;
  }

  let normalizedUrlPath = urlPath.split('?')[0].split('#')[0];

  while (normalizedUrlPath.length > 1 && normalizedUrlPath.endsWith('/')) {
    normalizedUrlPath = normalizedUrlPath.slice(0, -1);
  }

  return normalizedUrlPath || '/';
};
